





















































import mixins from 'vue-typed-mixins';
import S3Mixin from '@/components/mixins/s3';
import HeaderHamburger from '@/containers/header-hamburger/index.vue';
import Headwayapp from '@/components/Headwayapp.vue';

type HeaderItem = {
  url: string;
  icon: string;
  text: string;
  isSpaApp: boolean;
  isActive: boolean;
  klass: string;
};

export default mixins(S3Mixin).extend({
  components: {
    HeaderHamburger,
    Headwayapp,
  },
  props: {
    coverLetterId: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    isEditPage() {
      return !!this.coverLetterId;
    },
    headerItems(): HeaderItem[] {
      const makeHeaderItem = (url, icon, text, isSpaApp, klass): HeaderItem => {
        return {
          url,
          icon,
          text,
          isSpaApp,
          isActive: this.$route.path.startsWith(url),
          klass,
        };
      };

      return this.isEditPage
        ? [
            makeHeaderItem(
              `/app/cls/${this.coverLetterId}/edit`,
              'fa-pencil-alt',
              '編集',
              true,
              ''
            ),
            makeHeaderItem(
              `/cls/${this.coverLetterId}`,
              'fa-search-plus',
              'プレビュー',
              false,
              ''
            ),
          ]
        : [
            makeHeaderItem(
              `/app/cvs`,
              'fa-file-alt',
              'ダッシュボード',
              true,
              ''
            ),
          ];
    },
  },
});
